<div class="table-helper box-shadow">
  <table class="table-list" id="reports-table">
    <thead>
      <tr class="export-only-row">
        <td colspan="12" nowrap="nowrap">{{dateRangeText}}</td>
      </tr>
      <!-- <tr>
        <td></td>
        <td colspan="3"><span class="strong">letters</span></td>
        <td></td>
        <td></td>
        <td></td>
        <td colspan="2"><span class="strong">quality</span></td>
        <td colspan="2"><span class="strong">output rate</span></td>
        <td><span class="strong">time</span></td>
      </tr> -->
      <tr>
        <td class="table-header"><span class="strong">team</span></td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="lettersTeam"
                triggers="hover" placement="top"><strong>letters</strong>&nbsp;<img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active"  alt="letter answered"/></span>
          <ng-template #lettersTeam>
            <div [innerHTML]="reportsCopy.lettersAnswered | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="lettersChange"
                triggers="hover" placement="top">change <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active"  alt="change"/></span>
          <ng-template #lettersChange>
            <div [innerHTML]="reportsCopy.lettersChanged | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="lettersTotal"
                triggers="hover" placement="top">of total <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="of total"/></span>
          <ng-template #lettersTotal>
            <div [innerHTML]="reportsCopy.lettersTotal | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="lettersCanc"
                triggers="hover" placement="top">cancel <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="cancel"/></span>
          <ng-template #lettersCanc>
            <div [innerHTML]="reportsCopy.lettersCanc | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="lettersBespoke"
                triggers="hover" placement="top">bespoke <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="bespoke"/></span>
          <ng-template #lettersBespoke>
            <div [innerHTML]="reportsCopy.lettersBespoke | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="lettersOverride"
                triggers="hover" placement="top">override <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="override"/></span>
          <ng-template #lettersOverride>
            <div [innerHTML]="reportsCopy.lettersOverride | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="qualityReceived"
                triggers="hover" placement="top"><strong>quality</strong>&nbsp;<img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="quality"/></span>
          <ng-template #qualityReceived>
            <div [innerHTML]="reportsCopy.qualityReceived | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="qualityChange"
                triggers="hover" placement="top">change <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="change"/></span>
          <ng-template #qualityChange>
            <div [innerHTML]="reportsCopy.qualityChange | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="outputPp"
                triggers="hover" placement="top"><strong>output rate</strong>&nbsp;<img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active"alt="output rate" /></span>
          <ng-template #outputPp>
            <div [innerHTML]="reportsCopy.outputPp | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="outputChange"
                triggers="hover" placement="top">change <img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="change"/></span>
          <ng-template #outputChange>
            <div [innerHTML]="reportsCopy.outputChange | safe: 'html'"></div>
          </ng-template>
        </td>
        <td class="table-header">
          <span class="popover-item" [ngbPopover]="timeLetters"
                triggers="hover" placement="top"><strong>time in RM</strong>&nbsp;<img class="info-icon" [src]="constants.assetsPath + '/img/icons/icon-info.svg'"
                class="icon icon-active" alt="time in RM"/></span>
          <ng-template #timeLetters>
            <div [innerHTML]="reportsCopy.timeLetters | safe: 'html'"></div>
          </ng-template>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let teamReport of teamsReport">
        <td><span>{{teamReport.name}}</span></td>
        <td><span>{{teamReport.queriesAnswered}}</span></td>
        <td><span>{{teamReport.percentageChange}}</span></td>
        <td><span>{{teamReport.percentageOfTotal}}</span></td>
        <td><span>{{teamReport.percentageCancelled}}</span></td>
        <td><span>{{teamReport.percentageBespoke}}</span></td>
        <td><span>{{teamReport.percentageToSupervisor}}</span></td>
        <td><span>{{teamReport.percentageUnwantedFollowUps}}</span></td>
        <td><span>{{teamReport.percentageChangeUnwantedFollowUps}}</span></td>
        <td><span class="strong">{{teamReport.outputPerDay}}</span></td>
        <td><span>{{teamReport.percentageChangeOutput}}</span></td>
        <td><span class="strong">{{teamReport.percentageTimeOnLetters}}</span></td>
      </tr>
      <tr>
        <td><span class="strong">summary</span></td>
        <td>
          <span class="strong">
            {{totalTeamsReport.queriesAnswered}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageChange}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageOfTotal}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageCancelled}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageBespoke}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageToSupervisor}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageUnwantedFollowUps}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageChangeUnwantedFollowUps}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.outputPerDay}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageChangeOutput}}
          </span>
        </td>
        <td>
          <span class="strong">
            {{totalTeamsReport.percentageTimeOnLetters}}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
